

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import router from '@/router/index.js'
import store from '@/store/index.js'
import '@/tools/ArrayExtend.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'

import http from '@/api/request.js'
import '@/components/index.js'
import '@/style/animate.min.css'
import '@/tools/tools.js'
import '@/tools/DateExtend.js'
import { requestAmpUrl } from '@/plugin/monitoring'
import { requestRemoteIp } from './doman'
import { requestGetApiUrl } from './apiUrl'
import './vconsole'
Vue.use(DatetimePlugin)

Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)

Vue.use(VueRouter)

FastClick.attach(document.body)

Vue.prototype.http = http

Vue.config.productionTip = false

router.beforeEach(function (to, from, next) {
try {
window.document.title = to.name || to.matched[1].name
} catch (e) {

}
next()
})

router.afterEach(function (to) {

})

Promise.all([requestAmpUrl(), requestRemoteIp(), requestGetApiUrl()]).then(_ => {
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')
})
/* eslint-disable no-new */








// WEBPACK FOOTER //
// ./src/main.js